import React from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '@/lib/axios';
import { Button } from "@/components/ui/button";
import { useLoader } from "@/contexts/LoaderContext";
import { toast } from "sonner";
import { API_BASE_URL } from '@/config';
import { ShieldCheck, XCircle, Loader2 } from 'lucide-react';
import JourneyHeader from "@/components/JourneyHeader";

const LenderMockDecision: React.FC = () => {
    const navigate = useNavigate();
    const { setLoading } = useLoader();

    const handleAccept = async () => {
        navigate('/lender-simulation');
    };

    const handleReject = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`${API_BASE_URL}/api/reject_offer_by_lender/`);
            if (response.data.success) {
                navigate('/lender-rejected-explore');
            } else {
                toast.error("Failed to process rejection. Please try again.");
            }
        } catch (err) {
            console.error("Failed to reject offer", err);
            toast.error("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-white flex flex-col">
            <JourneyHeader />

            <main className="flex-1 flex flex-col items-center justify-center p-6 text-center">
                <div className="max-w-md w-full space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-700">
                    <div className="bg-blue-50 w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-6 relative">
                        <Loader2 className="w-12 h-12 text-intellend-green animate-spin absolute" />
                        <ShieldCheck className="w-8 h-8 text-intellend-green" />
                    </div>

                    <div className="space-y-4">
                        <h1 className="text-3xl font-bold text-gray-900 font-outfit">Lender Evaluation</h1>
                        <p className="text-lg text-gray-600 leading-relaxed">
                            The lender is currently reviewing your customized loan terms. This usually takes just a few moments.
                        </p>
                    </div>

                    <div className="bg-gray-50 border border-gray-100 rounded-2xl p-6 my-8">
                        <h2 className="text-sm font-semibold uppercase tracking-wider text-gray-400 mb-4">Mock Decision (Tester Only)</h2>
                        <div className="flex flex-col gap-4">
                            <Button
                                onClick={handleAccept}
                                className="bg-intellend-green hover:bg-intellend-green/90 text-white h-12 text-lg font-semibold rounded-xl shadow-md hover:shadow-lg transition-all"
                            >
                                Accept Offer
                            </Button>

                            <Button
                                variant="outline"
                                onClick={handleReject}
                                className="h-12 text-lg font-semibold rounded-xl border-red-200 hover:bg-red-50 text-red-600 group"
                            >
                                <XCircle className="mr-2 w-5 h-5 group-hover:scale-110 transition-transform" />
                                Reject Offer
                            </Button>
                        </div>
                    </div>

                    <p className="text-sm text-gray-400">
                        Please do not refresh this page.
                    </p>
                </div>
            </main>
        </div>
    );
};

export default LenderMockDecision;
